import { useState, useEffect, useContext } from 'react'
import { Grid, Typography, Button, FormControl, InputLabel, Select, MenuItem, Paper, IconButton, Modal, Box, CircularProgress, TextField } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { withStyles } from "@material-ui/core/styles"
import styles from './bankVerificationStyles'
import { DatePicker } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from "dayjs";
import { httpRequest } from '../../../../../ui-utils/api'
import { apiUrl, backendHosts } from '../../../../../ui-utils/apiConfig'
import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'
import snackError from '../../../../../helpers/snackError'
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CallIcon from '@mui/icons-material/Call'
import DialogBox from '../../../../Dialog Box/DialogBox'
import handleStartCall from '../../../../../helpers/handleStartCall'
import exportFromJSON from 'export-from-json'
import axios from 'axios'

const style = {
    position: "absolute !important",
    top: "50% !important",
    left: "50% !important",
    transform: "translate(-50%, -50%) !important",
    width: "50% !important",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "15px !important",
    "@media only screen and (max-width: 1650px)": {
        width: "80% !important",
    },
}

const buttondisabled = {
    width: '120px',
    backgroundColor: "#999999 !important",
    padding: "10px 5px !important",
    fontStyle: "normal !important",
    fontSize: "11px !important",
    color: "#FFFFFF !important",
    textTransform: "initial !important",
    fontFamily: "cardiuma-M !important",
    marginLeft: '20px'
}

const buttons = {
    width: '120px',
    backgroundColor: "#F74542 !important",
    padding: "10px 5px !important",
    fontStyle: "normal !important",
    fontSize: "11px !important",
    textTransform: "initial !important",
    fontFamily: "cardiuma-M !important",
    marginLeft: '20px'
}

const fontM = {
    fontFamily: "cardiuma-M !important"
}

const downloadButton = {
    width: '150px',
    background: "#F74542 !important",
    padding: "10px 5px !important",
    fontStyle: "normal !important",
    fontSize: "11px !important",

    color: "#FFFFFF !important",
    textTransform: "initial !important",
    fontFamily: "cardiuma-M !important",
    float: 'right !important',
    marginBottom: "3px !important",
}

const BankVerifictaion = ({ classes }) => {
    const { dispatch } = useContext(reducerContext)

    const [Fdate, setFdate] = useState(null)
    const [Tdate, setTdate] = useState(null)
    const [status, setStatus] = useState('Pending')
    const [fterror, setFTError] = useState("")
    const [bankList, setBankList] = useState([])
    const [columns, setColumns] = useState([])
    const [editModal, setEditModal] = useState(false)
    const [userData, setUserData] = useState({})
    const [loader, setLoader] = useState(false)
    const [docdata, setDocdata] = useState({})

    const [accNo, setAccNo] = useState("")
    const [ifsc, setIfsc] = useState("")
    const [upiid, setUpidid] = useState("")
    const [bankHolderName, setBankHolderName] = useState("")
    const [upiHolderName, setUpiHolderName] = useState("")
    const [bankName, setBankName] = useState("")
    const [branchName, setBranchName] = useState("")
    const [micr, setMicr] = useState("")
    const [remarks, setRemarks] = useState("")

    const [image, setImage] = useState(null);
    const [dailBoxOpen, setDailBoxOpen] = useState(false)
    const [selectedCustNumber, setSelectedCustNumber] = useState(null)

    const userName = localStorage.getItem('username')
    const agentId = JSON.parse(localStorage.getItem('sipRegData')).sip_id

    const handleClickOpen = (phNum) => {
        setDailBoxOpen(true)
        setSelectedCustNumber(phNum)
    }

    const handleCloseDail = () => {
        setDailBoxOpen(false)
    }

    useEffect(() => {
        const dynamicColumns = [
            {
                field: 'action',
                headerName: 'Action',
                align: "center",
                headerAlign: 'center',
               
                renderCell: (params) => (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '8px' }}>
                        {/* <IconButton
                            key={`call-${params.row.id}`}
                            onClick={() => handleClickOpen(params.row.mobile_number)} className={classes.cllIcnClr}>
                            <CallIcon style={{ fontSize: '18px' }} />
                        </IconButton> */}
                        <IconButton onClick={() => handleEditModal(params.row)} className={classes.edtIcnClr}>
                            <EditIcon style={{ fontSize: '18px', marginLeft: '10px' }} />
                        </IconButton>
                    </div>
                ),
            },
            {
                field: "mobile_number",
                headerName: "Phone",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "created_on",
                headerName: "Created_at",
                align: "center",
                headerAlign: "center",
                flex: 1,
                valueFormatter: (params) => {
                    return params != null ? params?.split("T")[0] : '-'
                }
            },
            {
                field: "client_id",
                headerName: "Client ID",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "pan_name",
                headerName: "Pan Name",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "account_no",
                headerName: "Acc No",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
            {
                field: "ifsc",
                headerName: "IFSC",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },


        ]

        if (userData?.status !== "AUTOMATIC" && status !== "Approved") {
            dynamicColumns.push({
                field: "failed_reason",
                headerName: "Verification Failed",
                align: "center",
                headerAlign: "center",
                flex: 1,
            });
        }

        dynamicColumns.push(
            {
                field: "status",
                headerName: "Status",
                align: "center",
                headerAlign: "center",
                flex: 1,
            },
        )

         if (status === "Rejected") {
            dynamicColumns.push(
                {
                    field: "verified_comments",
                    headerName: "Remark",
                    align: "center",
                    headerAlign: "center",
                    flex: 1,
                },
            )
        }


        if (status !== "Pending" && userData?.status !== "AUTOMATIC") {
            dynamicColumns.push(
                {
                    field: "verified_at",
                    headerName: status === "Rejected" ? "Rejected On" : "Approved On",
                    align: "center",
                    headerAlign: "center",
                    flex: 1,
                    valueFormatter: (params) => {
                        return params != null ? params?.split("T")[0] : '-'
                    }
                },
                {
                    field: "verified_by",
                    headerName: status === "Rejected" ? "Rejected By" : "Approved By",
                    align: "center",
                    headerAlign: "center",
                    flex: 1,
                    valueFormatter: (params) => {
                        return params != null ? params : '-'
                    }
                },

            );
        }

        setColumns(dynamicColumns)
    }, [status])


    const fetchBankList = async () => {
        try {
            // const bankResult = await httpRequest({
            //     endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.filterBankVerifyRecords}`,
            //     method: "get",
            //     instance: "instanceTwo",
            //     params: {
            //         type: status.toLowerCase()
            //     }
            // })

            const bankResult = await axios.get(`${backendHosts.BACK_OFFICE}${apiUrl.addBankFetchLogs}?type=${status.toLowerCase()}`)

            if (bankResult?.data?.status === 200 && bankResult?.data?.data?.success) {
                setBankList(bankResult?.data?.data?.data)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank verification List' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching bank verification List", bankResult)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank verification List' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error in fetching bank verification List", error)
        }
    }

   

    useEffect(() => {
        if (status) {
            fetchBankList()
        }
    }, [status])

    const handleFetchFile = async () => {
        try {
            // const docResult = await httpRequest({
            //     endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.getUploadFile}${userData.client_id}`,
            //     method: "get",
            //     instance: "instanceTwo"
            // })

            const docResult = await axios.get(`${backendHosts.BACK_OFFICE}${apiUrl.addBankChequeUpload}/${userData.client_id}/${userData.id}`)

            if (docResult?.data?.status === 200 && docResult?.data?.data?.success) {
                setDocdata(docResult?.data?.data)
            } else if (docResult.status === 404 && !docResult?.data.data.success) {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: docResult?.data.data.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank cheque/passbook.' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching bank cheque/passbook.", docResult?.data)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank cheque/passbook.' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error in fetching bank cheque/passbook.", error)
        }
    }

    useEffect(() => {
        if (Object.keys(userData).length > 0 && userData?.status !== 'AUTOMATIC') {
            handleFetchFile()
        }
    }, [userData])

    useEffect(() => {
        if (userData?.account_no) {
            setAccNo(userData.account_no);
        }
    }, [userData?.account_no]);

    useEffect(() => {
        if (userData?.ifsc) {
            setIfsc(userData.ifsc);
        }
    }, [userData?.ifsc]);

    useEffect(() => {
        if (userData?.upi_id) {
            setUpidid(userData.upi_id);
        }
    }, [userData?.upi_id]);


    const handleFDate = (newValue) => {
        setFdate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleTDate = (newValue) => {
        setTdate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault()
        if (Fdate === null) {
            setFTError("From Date is required *")
            return
        }

        if (Tdate === null) {
            setFTError(" To Date is required *")
            return
        }

        if (Fdate !== null || Tdate !== null) {
            setFTError("")
        }

        try {
            const bankResult = await axios.get(
                `${backendHosts.BACK_OFFICE}/filter-bankLogs?type=${status.toLowerCase()}&from=${Fdate}&to=${Tdate}`
            );

            if (bankResult?.data?.status === 200 && bankResult?.data?.data?.success) {
                setBankList(bankResult.data.data?.data)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank verification List' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching bank verification List", bankResult)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error in fetching bank verification List' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error in fetching bank verification List", error)
        }
    }

    const handleReset = () => {
        setFdate(null)
        setTdate(null)
        setFTError("")
        setStatus("Pending")
    }


    const handleDownloadCsv = () => {
        const header = ["Client ID", "PAN Name", "Acc No", "IFSC", "Verification Failed", "Status", "Phone", "Created At"]

        if (status !== 'Pending') {
            header.push(
                status === "Rejected" ? "Rejected On" : "Approved On",
                status === "Rejected" ? "Rejected By" : "Approved By"
            )
        }

        if (status !== 'Pending') {
            header.push(
                "Remarks"
            )
        }

        const data = bankList.map(item => {
            const row = {
                [header[0]]: `${item.client_id}`,
                [header[1]]: `${item.pan_name}`,
                [header[2]]: `="${item.account_no}"`,
                [header[3]]: `${item.ifsc}`,
                [header[4]]: item.failed_reason || "-",
                [header[5]]: `${item.status}`,
                [header[6]]: `${item.mobile_number}`,
                [header[7]]: `${item.created_on}`
            }

            if (status !== "Pending") {
                row[status === "Rejected" ? "Rejected On" : "Approved On"] = item.verified_at?.split("T")[0] || "-";
                row[status === "Rejected" ? "Rejected By" : "Approved By"] = item.verified_by || "-";
            }

            if (status !== "Pending") {
                row["Remarks"] = item.verified_comments || "-";
            }

            return row
        })

        exportFromJSON({
            data,
            fileName: 'bank_List',
            exportType: exportFromJSON.types.csv
        })
    }

    const handleStatusChangeDropDown = (e) => {
        setStatus(e.target.value)
    }

    const handleEditModal = (row) => {
        setEditModal(true);
        setUserData(row)
    }

    const handleClose = () => {
        setEditModal(false);
        setUserData({});
        setDocdata({})
        setAccNo("")
        setIfsc("")
        setUpidid("")
        setBankHolderName("")
        setUpiHolderName("")
        setImage(null)
        setBankName("")
        setBranchName("")
        setMicr("")
        setRemarks("")
    }

    const handleDownloadImage = () => {
        const base64Image = docdata?.base64
        const fileName = `${userData.client_id}_bank_document_${Date.now()}.jpg`

        const link = document.createElement('a')
        link.href = `data:image/jpeg;base64,${base64Image}`
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const handleValidateBank = async () => {
        if (!accNo.trim() || !ifsc.trim()) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Require Account Number or IFSC code' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            return
        }

        const payload = {
            "accountno": accNo,
            "ifsc": ifsc,
            "user_id": Number(userData.id)
        }
        setLoader(true)

        try {
            // const bankVerify = await httpRequest({
            //     endPoint: `${backendHosts.ADMIN}${apiUrl.BankVerify}`,
            //     method: "post",
            //     instance: "instanceOne",
            //     requestBody: payload,

            // })

            const bankVerify = await axios.post(`${backendHosts.ADMIN}${apiUrl.addBank_bankVerify}`,payload)

            if (bankVerify?.data?.status === 200) {
                const bankData = bankVerify?.data?.data?.name;
                setBankHolderName(bankData)
                setBankName(bankVerify?.data?.data?.bankName)
                setBranchName(bankVerify?.data?.data?.branch)
                setMicr(bankVerify?.data?.data?.micrno)
                setLoader(false)
            } else if (bankVerify.data?.status === 201) {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: bankVerify?.data?.data?.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                setLoader(false)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: bankVerify?.data?.data?.message || 'Error in Validate Bank API' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in Validate Bank API", bankVerify)
                setLoader(false)
            }

        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Unexpected error occurred' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error while calling Validate Bank API", error)
            setLoader(false)
        }
    }

    const handleValidateUPI = async () => {
        if (!upiid.trim()) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Require UPI Id' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            return
        }

        const payload = {
            "upi_id": upiid,
            "user_id": Number(userData.id)
        }

        setLoader(true)

        try {
            // const upiVerify = await httpRequest({
            //     endPoint: `${backendHosts.REG}${apiUrl.UpiVerify}`,
            //     method: "post",
            //     instance: "instanceOne",
            //     requestBody: payload
            // })


            const upiVerify = await axios.post(`${backendHosts.ADMIN}${apiUrl.addBankUpiVerify}`, payload)

            if (upiVerify?.data.status === 200) {
                const upiData = upiVerify?.data?.data?.fullname
                setUpiHolderName(upiData)
                setLoader(false)
            } else if (upiVerify?.data?.status === 201) {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: upiVerify?.data?.data?.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                setLoader(false)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'UPI verification failed' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("UPI verification failed", upiVerify)
                setLoader(false)
            }

        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'UPI verification failed' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("UPI verification failed", error)
            setLoader(false)
        }
    }

    const handleBankDecision = async (actionStatus,status,address) => {
        console.log("✅✅", status, address, upiid)

        const payload = {
            "clientId": userData.client_id,
            accNo: status == "AUTOMATIC" ? userData?.account_no :accNo,
            bankName: status == "AUTOMATIC" ? userData?.bank_name : bankName, 
            branchName: status == "AUTOMATIC" ? address : branchName,
            "defaultAcct": userData?.default_account,
            micr: status == "AUTOMATIC" ? userData?.micr : micr,
            ifsc,
            bankHolderName: status == "AUTOMATIC" ? userData?.bank_verify_name : bankHolderName, 
            verified_comments: remarks,
            verified_by: `${userName}-${agentId}`,
            status: actionStatus,
            ...(upiid && { upi: upiid }),
            ...(upiHolderName && { upiHolderName })
        }

        console.log("Payload✅",payload)

        setLoader(true)

        try {

            // const manualVerify = await httpRequest({
            //     endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.bankManualVerify}`,
            //     method: "post",
            //     instance: "instanceTwo",
            //     requestBody: payload,
            // })

            const manualVerify = await axios.post(`${backendHosts.BACK_OFFICE}${apiUrl.addBankVerify}`,payload)
            const { success, message, techExcelRes } = manualVerify?.data?.data

            if (manualVerify?.data.status === 200 && success) {
                setLoader(false)
                fetchBankList()
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
                handleClose()

            } else if (manualVerify.status === 400 && !success) {
                setLoader(false)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            } else if (manualVerify.status === 404 && !success) {
                setLoader(false)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            } else {
                setLoader(false)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Bank Manual verify failed' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Bank Manual verify failed", techExcelRes)
            }

        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Bank Manual verify failed' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Bank Manual verify failed", error)
            setLoader(false)
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (!file) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true });
            dispatch({ type: 'SET_ERROR', payload: 'Please select file' });
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
            return;
        }

        const fileType = file.type;
        const fileSizeMB = file.size / (1024 * 1024);

        if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true });
            dispatch({ type: 'SET_ERROR', payload: 'Only JPEG or PNG images are allowed.' });
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
            return;
        }

        if (fileSizeMB > 3) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true });
            dispatch({ type: 'SET_ERROR', payload: 'Image size must be 3MB or less.' });
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
            return;
        }

        setImage(file);

      
    };


    // const handlePicFile = async (file, type) => {// added by dev-kartik on 02-04-25
    //     if (!file) {
    //         console.error("No file selected.");
    //         setEnable(false);
    //         return;
    //     }

    //     const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
    //     if (!validImageTypes.includes(file.type)) {
    //         setError("Invalid file type. Please upload an image (JPEG, PNG, JPG).");
    //         setFileName("");
    //         setEnable(false);
    //         return;
    //     }

    //     const maxSize = 5 * 1024 * 1024; // 1 MB
    //     if (file.size > maxSize) {
    //         setError("File size exceeds the 5MB limit.");
    //         setFileName("");
    //         setEnable(false);
    //         return;
    //     }

    //     try {
    //         const fileReader = new FileReader();
    //         fileReader.onload = async () => {
    //             try {
    //                 // FileReader provides a Base64-encoded string for image files
    //                 const base64Image = fileReader.result.split(",")[1];
    //                 // console.log(base64Image);
    //                 const data = `data:image/jpeg;base64,${base64Image}`;
    //                 setBaseData(data);
    //                 setEnable(true);
    //                 setError("");
    //             } catch (error) {
    //                 console.error("Error converting image to Base64:", error);
    //             }
    //         };

    //         fileReader.readAsDataURL(file); // Triggers Base64 encoding
    //     } catch (error) {
    //         console.error("Error reading file:", error);
    //         // setInccorectErr("Error reading the file.");
    //     }
    //     setFileName(file.name);
    // };


    const handleUploadToS3 = async () => {
        console.log("hellowww")
       

        const formData = new FormData()

        formData.append('client_id', userData.client_id)
        formData.append('mobile_no', userData.mobile_number)
        formData.append('file', image);

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }

        // console.log(formData)

        setLoader(true)
        try {
            // const fileRes = await httpRequest({
            //     endPoint: `${backendHosts.BACK_OFFICE}${apiUrl.bankDocUpload}`,
            //     method: "post",
            //     instance: "instanceTwo",
            //     requestBody: formData,
            //     isFileUpload: true,
            //     headers: {
            //         "Content-Type": "multipart/form-data",
            //     }
            // })

            const fileRes = await axios.post(`${backendHosts.BACK_OFFICE}${apiUrl.addBankChequeUpload}`, formData)

            console.log("Upload success:", fileRes)
            setLoader(false)

            if (fileRes.data.status === 200 && fileRes?.data?.data.success) {
                handleFetchFile()
                setLoader(false)
                setImage(null)
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: fileRes?.data.data.message })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
            }

        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'File upload to S3 failed.' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("File upload to S3 failed", error)
            setLoader(false)
        }
    }

    return (
        <Grid container direction="column" sx={{ padding: '0px 0px 0px 0px',height:"100%"}}>
            {/* Filter Form */}
            <form className={classes.fnoFormDateField} onSubmit={handleFormSubmit}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <DatePicker
                                label="From"
                                format="DD-MM-YYYY"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ className: classes.input }}
                                className={classes.datePicker}
                                value={Fdate ? dayjs(Fdate) : null}
                                onChange={handleFDate}
                            />
                        </Grid>

                        <Grid item>
                            <DatePicker
                                label="To"
                                format="DD-MM-YYYY"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ className: classes.input }}
                                className={classes.datePicker}
                                value={Tdate ? dayjs(Tdate) : null}
                                onChange={handleTDate}
                            />
                        </Grid>

                        <Grid item>
                            <Button
                                type="submit"
                                sx={{
                                    width: 100,
                                    height: 34,
                                    backgroundColor: '#F44748',
                                    color: '#fff',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: 11,
                                    '&:hover': {
                                        backgroundColor: '#F44748', // same as normal
                                    },
                                }}
                            >
                                Submit
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                onClick={handleReset}
                                sx={{
                                    width: 100,
                                    height: 34,
                                    backgroundColor: '#F44748',
                                    color: '#fff',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: 11,
                                    '&:hover': {
                                        backgroundColor: '#F44748', // same as normal
                                    },
                                }}
                            >
                                Reset
                            </Button>
                        </Grid>

                        <Grid item>
                            <Button
                                onClick={handleDownloadCsv}
                                sx={{
                                    color: '#F3D45E',
                                    textDecoration: 'underline',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: '13px',
                                    fontStyle: 'normal',
                                    fontWeight: 'bold',
                                }}
                            >
                                Download CSV
                            </Button>
                        </Grid>

                        <Grid item sx={{ minWidth: 200 }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel className={classes.inputColor} id="status-select-label">
                                    Status
                                </InputLabel>
                                <Select
                                    labelId="status-select-label"
                                    value={status}
                                    onChange={handleStatusChangeDropDown}
                                    displayEmpty
                                    className={classes.select}
                                    sx={{
                                        height: 40,
                                        '.MuiSelect-icon': {
                                            color: 'white !important',
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: { top: '50px' },
                                        },
                                    }}
                                >
                                    {['Pending', 'Approved', 'Rejected'].map((item) => (
                                        <MenuItem key={item} value={item} className={classes.intSelText}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                </LocalizationProvider>
            </form>
            {fterror && <Typography color="error" sx={{ fontSize: "14px" }} mb={1} >{fterror}</Typography>}

            {/* Data Grid */}
            <Paper
                className={classes.horizantalTablayout}
                sx={{ height: "70vh" }}
            >
                <DataGrid
                    rows={bankList}
                    columns={columns}
                    className={classes.customDataGrid}
                    sx={{
                        "--DataGrid-containerBackground": "#131E2E",
                        "--DataGrid-rowBorderColor": "#000",
                        border: 0,
                        width: "100%",
                    }}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 25 },
                        },
                    }}
                    pageSizeOptions={[25, 50, 75, 100]}
                    getRowId={(row) => row.id}
                />

                <DialogBox
                    open={dailBoxOpen}
                    handleClose={handleCloseDail}
                    customerNumber={selectedCustNumber}
                    dispatch={dispatch}
                    handleStartCall={handleStartCall}
                />
            </Paper>
            <Modal
                open={editModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                userData={userData}
            >
                <Box
                    sx={{ ...style, padding: "20px" }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            width: "100%",
                            position: "relative",
                            marginBottom: '10px'
                        }}
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{
                                fontFamily: "cardiuma-M",
                                fontWeight: "bold",
                            }}
                        >
                            Document Verification
                        </Typography>

                        {/* Close Button */}
                        <Button
                            onClick={handleClose}
                            sx={{
                                minWidth: "unset",
                                padding: "0",
                                position: "absolute",
                                right: 0,
                                top: 0,
                            }}
                        >
                            <CloseIcon style={{ color: "red" }} />
                        </Button>
                    </Box>

                    {userData?.status !== 'AUTOMATIC' && (
                        <>
                            {image ? (
                                <Grid
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100px',
                                        border: '1px solid #eeeeee',
                                        borderRadius: '15px',
                                        backgroundColor: '#fafafa',
                                        padding: '16px',
                                        textAlign: 'center'
                                    }}
                                >
                                    <Typography sx={{
                                        fontSize: "14px",
                                        fontFamily: "cardiuma-M ! important",
                                        color: "#000000",
                                        wordBreak: 'break-word'
                                    }}>
                                        {image?.name || 'File Selected'}
                                    </Typography>
                                </Grid>
                            ) : docdata?.base64 ? (
                                <Grid
                                    sx={{
                                        height: '200px', overflowY: 'scroll', "&::-webkit-scrollbar": {
                                            width: "5px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: "#dddddd"
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#bbbbbb"
                                        }, border: '1px solid #eeeeee', borderRadius: '15px !important'
                                    }}>

                                    <img src={`data:image/jpeg;base64,${docdata?.base64}`} width="100%" alt="Uploaded Document" />
                                </Grid>
                            ) : (
                                <Grid
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center !important',
                                        margin: '50px 0px 50px 0px !important',
                                    }}
                                >
                                    <Typography

                                    >No File Uploaded</Typography>
                                </Grid>
                            )}
                        </>
                    )}

                    <Grid sx={{ width: '100% !important', display: 'flex !important', justifyContent: 'center !important', marginTop: '10px !important' }}>
                        <Grid container sx={{ width: '900px !important' }} >
                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, mb: 1 }}>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', }}>
                                    {loader && <CircularProgress size={30} />}
                                </Grid>
                                {/* Disable for Franchise Dept - srini - 05-03-25 */}
                                {docdata?.base64 && (<Button sx={downloadButton} onClick={handleDownloadImage}>
                                    DOWNLOAD IMAGE
                                </Button>)}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid xl={4} lg={4} md={4} sm={6} xs={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end !important' }} >
                            <Typography mb={2} sx={fontM}>Client Id:</Typography>
                            <Typography mb={2} sx={fontM}>Aadhar Name:</Typography>
                            <Typography mb={2} sx={fontM}>Pan Name:</Typography>
                            <Typography mb={2} sx={fontM}>Account No:</Typography>
                            <Typography mb={2} sx={fontM}>IFSC:</Typography>
                            <Typography sx={fontM} mb={2}>Bank Account Holder Name:</Typography>
                            {userData?.status !== 'AUTOMATIC' ?
                                <>
                                    <Typography mb={2} sx={fontM}>UPI Id:</Typography>
                                    <Typography sx={fontM} mb={2}>UPI ID Bank Account Holder Name:</Typography>
                                </>
                                :
                                <>
                                    {
                                        userData?.upi_id &&
                                        <>
                                            <Typography mb={2} sx={fontM}>UPI Id:</Typography>
                                        </>

                                    }
                                </> 
                            }
                          
                        <Typography sx={fontM}>Approve/Reject Comments:</Typography>
                        </Grid>
                        <Grid xl={8} lg={8} md={8} sm={6} xs={6} pl={2} >
                            <TextField
                                value={userData?.client_id}
                                size='small'
                                type="text"
                                style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                inputProps={{
                                    readOnly: status !== 'Pending',
                                    style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                }}
                            />
                            <TextField
                                value={userData?.aadhaar_name}
                                size='small'
                                type="text"
                                style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                inputProps={{
                                    readOnly: status !== 'Pending',
                                    style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                }}
                            />
                            <TextField
                                value={userData?.pan_name}
                                size='small'
                                type="text"

                                style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                inputProps={{
                                    readOnly: status !== 'Pending',
                                    style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                }}
                            />
                            <TextField
                                value={accNo}
                                size='small'
                                type="text"
                                style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                inputProps={{
                                    readOnly: status !== 'Pending' || !!bankHolderName,
                                    style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                }}
                                onChange={(e) => { setAccNo(e.target.value) }}
                            />
                            <TextField
                                value={ifsc}
                                size='small'
                                type="text"
                                style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                inputProps={{
                                    readOnly: status !== 'Pending' || !!bankHolderName,
                                    style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                }}
                                onChange={(e) => { setIfsc(e.target.value) }}
                            />
                           
                            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <TextField
                                    value={bankHolderName || userData?.bank_verify_name}
                                    size='small'
                                    type="text"
                                    style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                    inputProps={{
                                        readOnly: status !== 'Pending',
                                        style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                    }}
                                />
                                <Box sx={{ width: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                    {bankHolderName && <CheckCircleIcon sx={{ color: 'green', fontSize: 18, }} />}
                                </Box>

                                {(status === 'Pending' && userData?.status !== 'AUTOMATIC') && (
                                    <Button variant="contained" sx={{ ...(bankHolderName ? buttondisabled : buttons), height: '30px',  }} onClick={handleValidateBank} disabled={!!bankHolderName}>
                                        VALIDATE
                                    </Button>
                                )}
                            </Grid>
                            {
                                (!userData?.upi_id && userData?.status == 'AUTOMATIC') ?
                                <></>
                                :

                                    <TextField
                                        value={upiid}
                                        size='small'
                                        type="text"
                                        style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                        inputProps={{
                                            readOnly: status !== 'Pending' || !!upiHolderName,
                                            style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                        }}
                                        onChange={(e) => { setUpidid(e.target.value) }}
                                    />
                            }
                           

                            {
                                userData?.status !== 'AUTOMATIC' && <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <TextField
                                        value={upiHolderName || userData?.upi_verify_name}
                                        size='small'
                                        type="text"
                                        style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                        inputProps={{
                                            readOnly: status !== 'Pending',
                                            style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                        }}
                                    />
                                    <Box sx={{ width: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                                        {upiHolderName && <CheckCircleIcon sx={{ color: 'green', fontSize: 18, }} />}
                                    </Box>
                                    {status === 'Pending' && (
                                        <Button variant="contained" sx={{ ...(upiHolderName ? buttondisabled : buttons), height: '30px' }} onClick={handleValidateUPI} disabled={!!upiHolderName}>
                                            VALIDATE
                                        </Button>
                                    )}
                                </Grid>
                            }    
                        
                                <TextField
                                    value={remarks || userData?.verified_comments}
                                    size='large'
                                    type="text"
                                    multiline
                                    maxRows={3}
                                    style={{ alignContent: 'center', justifyContent: 'center', marginBottom: '8px' }}
                                    inputProps={{
                                        readOnly: status !== 'Pending',
                                        style: { alignItems: 'center', fontSize: '14px', fontFamily: "cardiuma-regular", height: '15px', width: '400px' }
                                    }}
                                    onChange={(e) => { setRemarks(e.target.value) }}
                                />
                        </Grid>
                    </Grid>
                    <Grid mt={3} sx={{ float: 'right', marginRight: '3% !important' }} >
                        {status === 'Pending' && (
                            <>
                                {(!image && userData?.status !== 'AUTOMATIC')  && (
                                    <>
                                        <input
                                            id="bank-upload"
                                            accept=".jpeg, .jpg, .png"
                                            type="file"
                                            hidden
                                            onChange={handleFileChange}
                                        />
                                        <label htmlFor="bank-upload">
                                            <Button
                                                component="span"
                                                variant="contained"
                                                sx={buttons}
                                            >
                                                SELECT FILE
                                            </Button>
                                        </label>
                                    </>
                                )}

                                {image && <Button variant="contained" sx={buttons} onClick={handleUploadToS3}>
                                    UPLOAD
                                </Button>}

                                {userData?.status !== 'AUTOMATIC' &&(<Button variant="contained" sx={remarks ? buttons : buttondisabled} disabled={!remarks}
                                    onClick={() => handleBankDecision("reject")}
                                >
                                    REJECT
                                </Button>)}

                                {userData?.status !== 'AUTOMATIC' ? (
                                    <Button variant="contained" mr={2}
                                    disabled={!(docdata?.base64 && bankHolderName && remarks)}
                                    sx={
                                        docdata?.base64 && bankHolderName && remarks
                                            ? buttons
                                            : buttondisabled
                                    }
                                    onClick={() => handleBankDecision("approve")}
                                >
                                    APPROVE
                                </Button>)
                                :
                                (
                                    <Button variant="contained" mr={2}
                                    sx={
                                        remarks
                                            ? buttons
                                            : buttondisabled     
                                    }
                                            onClick={() => handleBankDecision("approve", userData?.status, userData?.bank_branch)}
                                >
                                    APPROVE
                                </Button>)
                                }
                            </>
                        )}
                    </Grid>
                </Box>

            </Modal>


        </Grid>
    )
}

export default withStyles(styles)(BankVerifictaion)
